module.exports = __webpack_public_path__ + "static/media/16.a006e8b9.png";